export default __webpack_public_path__ + "static/media/so.8f71d6a0.png";